import React, { useState } from "react";
import { connect } from 'react-redux';
import history from '../history.js';
import { sendRegistroModdle, loadConsults, updateStateUser, accesoAdministrador, parseParams, verificarCondicones, getCursosSocio, verificarInvitacion } from '../actionCreators';
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBBtn, MDBCardImage, MDBInput, MDBModalFooter, MDBIcon, MDBCardTitle, MDBSelect, MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import store from '../store'
import alertify from 'alertifyjs';
import { Select } from 'antd';
import {
  UserOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { Modal, Button } from 'antd';


const { Option } = Select;

const onChange = (val) => {
  store.dispatch({
    type: "STATE_IDCURSO",
    idCurso: val
  })
}


const verificarEsatodo = () => {
  const registro = store.getState().allCourse;
  let activar = true;
  /*
  let params = parseParams(window.location.search);

  if (params.socio !== undefined) {
    activar = false
}
*/

  if (registro !== undefined) {
    if (Object.keys(registro).length > 0) {
      activar = false
    }
  }

  return activar;
}


const Login = ({ user, urlweb, aceptoCondiciones, allCourse, nombreSocio }) => {
  const params = parseParams(window.location.search);
  const estadoActual = store.getState().user;
  const alta = { email: estadoActual.email, nombre: estadoActual.nombre, apellido1: estadoActual.apellido1, apellido2: estadoActual.apellido2, telefono: estadoActual.telefono, cif: estadoActual.cif, idSocio: estadoActual.idSocio }
  getCursosSocio(params.socio);


  const MSGAltaUsuario = () => {
    Modal.info({
      content: (
        <div>
          <img src="./academyGris.png" alt="logo academy" style={{ width: '400px' }} ></img>

          <h4 className="m-4">Se ha registrado correctamente en el curso, el día anterior del curso recibirá un email con los datos de acceso.</h4>

          <img src="./patrocinadores.jpg" style={{ width: '730px' }} ></img>
        </div>
      ),
      width: (800),
      footer: (null),
      okText: "Entendido.",
      onOk() { },
    });
  }


  /*
    if (params.socio === undefined) {
      if(urlweb !== ""){
        window.location.replace(urlweb);
      }else{
        alertify.set('notifier', 'position', 'top-right');
        alertify.warning('Formato incorrecto de url, falta socio');
      }
    } 
  */


  return (
    <div >
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '100vh' }} >
              <MDBCard className="col-md-9 mt-4">

                <img src="./academyGris.png" alt="logo academy" style={{ width: '300px' }} className='pt-4'></img>
                {nombreSocio !== undefined ?
                  nombreSocio !== "" ?
                    <MDBCardTitle className="text-center mt-4 mb-0" style={{ fontSize: "36px" }}>{nombreSocio}</MDBCardTitle>
                    : null
                  : null
                }

                <h5><UserOutlined style={{ fontSize: "20px", verticalAlign: 'top' }} /> Formulario de inscripción para la formación</h5>
                <MDBCardBody>
                  <Select
                    showSearch
                    style={{ width: "100%", textAlign: 'left' }}
                    placeholder="Selecciona tu curso"
                    optionFilterProp="children"
                    className="mb-3"
                    onChange={(e) => { onChange(e) }}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {allCourse !== undefined ?
                      Object.keys(allCourse).length > 0 ?
                        allCourse.map((item) =>
                          <Option value={item.ID}>{item.NOMBRE}</Option>
                        )
                        :
                        null
                      :
                      null}
                  </Select>

                  <img src="./patrocinadores.jpg" style={{ width: '700px' }} ></img>

                  <div className="custom-control custom-checkbox mt-3" style={{ textAlign: "left" }}>
                    <input type="checkbox" className="custom-control-input" id="chkInvitacion" onClick={(e) => { store.dispatch(verificarInvitacion(e)) }} />
                    <label className="custom-control-label" style={{ fontSize: "18px", fontWeight: 'bold' }} htmlFor="chkInvitacion"> Marque esta casilla en el caso de no pertenecer a ninguna de las redes del Grupo Serca</label>
                  </div>


                  <MDBInput label="Escribe tu nombre" size="sm" value={user.nombre !== undefined ? user.nombre : ""} onChange={(e) => { alta.nombre = e.target.value; store.dispatch(updateStateUser(alta)) }} />
                  <MDBInput label="Escribe tu nombre primer apellido" size="sm" value={user.apellido1 !== undefined ? user.apellido1 : ""} onChange={(e) => { alta.apellido1 = e.target.value; store.dispatch(updateStateUser(alta)) }} />
                  <MDBInput label="Escribe tu nombre segundo apellido" size="sm" value={user.apellido2 !== undefined ? user.apellido2 : ""} onChange={(e) => { alta.apellido2 = e.target.value; store.dispatch(updateStateUser(alta)) }} />
                  <MDBInput autoComplete="off" type="email" label="Escribe tu correo electrónico" size="sm" value={user.email !== undefined ? user.email : ""} onChange={(e) => { alta.email = e.target.value; store.dispatch(updateStateUser(alta)) }} />

                  <MDBInput label="Escribe tu telefono" size="sm" type="text" value={user.telefono !== undefined ? user.telefono : ""} onChange={(e) => { alta.telefono = e.target.value; store.dispatch(updateStateUser(alta)) }} />
                  <MDBInput label="Escribe el CIF del taller" size="sm" type="text" value={user.cif !== undefined ? user.cif : ""} onChange={(e) => { alta.cif = e.target.value; store.dispatch(updateStateUser(alta)) }} />

                  <form>
                    <div>

                      <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" id="defaultUnchecked" onClick={(e) => { store.dispatch(verificarCondicones(e)) }} disabled={verificarEsatodo()} />
                        <label className="custom-control-label" style={{ textAlign: 'initial' }} htmlFor="defaultUnchecked"> He entendido y acepto las <a href="#" onClick={(e) => { history.push("/condiciones") }}  >Condiciones de Servicio</a>      y la <a href="#" onClick={(e) => { history.push("/privacidad") }}>Política de Privacidad</a> , otorgando mi consentimiento informado.</label>
                      </div>

                      <div style={{ float: "left" }}>
                      

                        <MDBBtn disabled={aceptoCondiciones} color="indigo" onClick={() => { sendRegistroModdle(user) }} className="z-depth-1 text-bold" style={{ fontWeight: "900" }}>
                          <MDBIcon icon="save" className="mr-1" /> REGISTRAME</MDBBtn>
                      </div>
                    </div>


                    {/* <div className="text-center py-4 mt-3">
                      <MDBBtn color="indigo" onClick={() => sendRegistroModdle(user)} className="btn-block z-depth-2 text-bold" style={{ fontWeight: "900" }}>
                        Alta usuario</MDBBtn>
                    </div>
  */}
                  </form>
                </MDBCardBody>
                <MDBModalFooter>
                  <div className="font-weight-light" style={{ cursor: 'pointer' }}
                    onClick={() => alertify.prompt('Acceso al administrador', 'Ingresa la contraseña', ''
                      , function (evt, value) { accesoAdministrador(value) }
                      , function () { }).set('type', 'password')}>
                    <p>Acceso administrador</p>
                  </div>
                </MDBModalFooter>
              </MDBCard>



              <MDBCard className="col-md-9 mt-4 mb-4">
                <MDBCardBody>
                  <div className="contact-info">
                    <h4 className='card-title'>Información básica sobre la protección de datos.</h4>

                    <div className="sep"></div>
                    <p><strong>Responsable del fichero:</strong> VETURILO, S.A.</p>
                    <div className="sep"></div>
                    <p><strong>Finalidad:</strong> Poder contactar contigo en relación a tu consulta o petición, así como enviarte información comercial sobre nuestros servicios y productos</p>
                    <div className="sep"></div>
                    <p><strong>Legitimación:</strong> Marcando la casilla de aceptación estás aceptando nuestra <a href="#" onClick={(e) => { history.push("/privacidad") }}> Política de Privacidad</a></p>
                    <div className="sep"></div>
                    <p><strong>Destinatarios:</strong> Empresas proveedoras nacionales, de la Unión Europea y encargados de tratamiento acogidos a Privacy Shield</p>
                    <div className="sep"></div>
                    <p><strong>Derechos:</strong> Acceder, rectificar, limitar o suprimir tus datos, así como solicitar la portabilidad, limitación u oposición a su tratamiento</p>
                    <div className="sep"></div>
                    <p><strong>Información adicional:</strong> Puedes consultar la información completa y detallada sobre protección de datos en el siguiente <a href="#" onClick={(e) => { history.push("/privacidad") }}>enlace</a></p>

                  </div>
                </MDBCardBody>

              </MDBCard>
            </div>
          </MDBCol>
        </MDBRow>
        {/*
        <Modal
          title="Alta para la formación"
          centered
          visible={visible}
          footer={null}
          afterClose={() => setVisible(false)}
          
          width={500}
        >
          <p>Se ha registrado correctamente en el curso.</p>
         
        </Modal>
*/}
      </MDBContainer>
    </div>
  );
}
const mapStateToProps = state => {
  return {
    user: state.user,
    urlweb: state.urlweb,
    aceptoCondiciones: state.aceptoCondiciones,
    allCourse: state.allCourse,
    nombreSocio: state.nombreSocio
  };
}

export default connect(mapStateToProps)(Login);


